export default {
  state: {
    isCollapse: false,
    collapseWidth: '64px',
    unCollapseWidth: '255px'
  },
  getters: {},
  mutations: {
    toggleCollapse(state) {
      state.isCollapse = !state.isCollapse
    }
  },
  actions: {
  }
}
